module.exports = __webpack_public_path__ + "static/media/short-hair-layered.6aa4616c.png";